class PosProducts {
  static transform(products) {
    let transformedProducts = [];
    products.forEach(i => {
      transformedProducts.push({
        saleProductId: i.saleProductId ? i.saleProductId : "",
        productId: i.productId,
        name: i.product ? i.product.name : "",
        price: i.price,
        discount: i.discount,
        productDiscount: i.isPercentage ? "percent" : "amount",
        quantity: i.quantity,
        productPriceTypeId: i.productPriceTypeId,
        hsn: i.product ? i.product.hsn : "",
        unit: i.product ? i.product.unit.label : "",
        taxRate: i.taxRate ? i.taxRate : 0,
        priceType: i.productPriceType ? i.productPriceType.label : "",
        prices: (i.product.prices || []).map(p => ({
          price: p.price,
          defaultDiscount: p.defaultDiscount,
          productPriceTypeId: p.productPriceTypeId,
          productPriceTypeLabel: p.productPriceType ? p.productPriceType.label : (p.productPriceTypeLabel || ''),
          fromQuantity: p.fromQuantity,
          startDate: p.startDate,
          endDate: p.endDate,
        }))
      });
    });
    return transformedProducts;
  }
}

export default PosProducts;
